/**
 * 삼쩜삼 앱 딥링크.
 *
 * 두 링크는 서로 다른 캠페인 타깃이라 합치지 않는다 — 하나로 합치면
 * 유입 경로 구분이 사라진다.
 */

/** 상단 네비게이션 / 홈 히어로의 "앱에서 확인하기" 진입. */
export const DEEPLINK_APP_ENTRY = 'https://tl.3o3.co.kr/oh8r45c';

/** 랜딩·프리뷰의 혜택 확인 CTA (스티키 / 프로모 배너). */
export const DEEPLINK_BENEFIT_CTA = 'https://tl.3o3.co.kr/jcasz4';

/** 홈(benefit.3o3.co.kr) 의 앱 진입 CTA — 네비 / 히어로 / 하단 배너. */
export const DEEPLINK_BENEFIT_SITE_HOME = 'https://tl.3o3.co.kr/benefit_3o3_co_kr';
